// import React, { useState } from "react";
// import loginLogo from "../../Assets/Images/login-logo.png";
// import "../../Assets/Images/loginPage-banner.jpg";
// import "../../Pages/LoginPage/LoginPage.scss";
// import { Link, Navigate, useNavigate } from "react-router-dom";
// import axios from "axios";
// import Cookies from "js-cookie";
// import { API_BASE_URL } from "../../utils/index";
// import Swal from "sweetalert2";

// export default function Login() {
//   const [email, setEmail] = useState("");
//   const [verifyPassword, setVerifyPassword] = useState("");
//   const [hide, setHide] = useState(false);

//   const navigate = useNavigate();

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     axios
//       .post(`${API_BASE_URL}/admin/login`, {
//         email: email,
//         password: verifyPassword,
//       })
//       .then((result) => {
//         console.log("result Login", result.data);
//         // navigate("/profilepage");
//         navigate("/");
//         Swal.fire({
//           icon: "success",
//           title: "Login Success",
//           showConfirmButton: false,
//           timer: 1500,
//         });
//         const adminId = result.data?.token;

//         localStorage.setItem("adminId", adminId);
//       })
//       .catch((error) => {
//         console.log("error", error);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: error.response.data.message,
//         });
//       });
//   };

//   return (
//     <div className="login-page  d-flex align-items-center ">
//       <div className="container ">
//         <div className="row ">
//           <div className="col-md-6">
//             <div className="login-logor text-center">
//               <img src={loginLogo} alt="loginLogo" />
//             </div>
//           </div>
//           <div className="col-md-6">
//             <form className="right" onSubmit={handleSubmit}>
//               <p className="login-title">Login into your account</p>
//               <div className="my-2">
//                 <input
//                   className="form-control"
//                   type="email"
//                   name="email"
//                   id="email"
//                   placeholder="E-Mail Id"
//                   required
//                   onChange={(e) => setEmail(e.target.value)}
//                 />
//               </div>
//               <div className="my-2 password-input">
//                 <input
//                   className="form-control"
//                   type={hide ? "text" : "password"}
//                   name="password"
//                   id="password"
//                   value={verifyPassword}
//                   placeholder="Password"
//                   required
//                   onChange={(e) => setVerifyPassword(e.target.value)}
//                 />

//                 <button type="button" onClick={() => setHide(!hide)}>
//                   {hide ? "Hide" : "Show"}
//                 </button>
//               </div>

//               <div className="my-2">
//                 <button type="submit" className="btn submit-button w-25 ">
//                   Login
//                 </button>
//               </div>
//               {/* <div>
//                 <input type="checkbox" className="form-check-input" />
//                 <lable className="form-check-label px-2">
//                   Keep me logged in
//                 </lable>
//               </div> */}
//               {/* <Link to="/" className="text-light">
//                 Go to Register
//               </Link> */}
//             </form>
//             {/* <button onClick={check}>Run Fetch</button>  */}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Typography,
  Paper,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import loginLogo from "../../Assets/Images/login-logo.png";
import { API_BASE_URL } from "../../utils/index";

export default function Login() {
  const [email, setEmail] = useState("");
  const [verifyPassword, setVerifyPassword] = useState("");
  const [hide, setHide] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    axios
      .post(`${API_BASE_URL}/admin/login`, {
        email,
        password: verifyPassword,
      })
      .then((result) => {
        const adminId = result.data?.token;
        localStorage.setItem("adminId", adminId);
        navigate("/");

        Swal.fire({
          icon: "success",
          title: "Login Success",
          showConfirmButton: false,
          timer: 1500,
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.response?.data?.message || "Something went wrong!",
        });
      });
  };

  return (
    <Box
      className="login-page"
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        // background: "#f5f5f5",
      }}
    >
      <Grid container spacing={4} justifyContent="center">
        {/* Left side - Logo */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box component="img" src={loginLogo} alt="loginLogo" sx={{ width: "80%", maxWidth: 400 }} />
        </Grid>

        {/* Right side - Login Form */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 4, maxWidth: 400, mx: "auto" }}>
            <form onSubmit={handleSubmit}>
              <Typography variant="h5" gutterBottom style={{ fontFamily: "Poppins", textAlign: "center" }}>
                Admin Login
              </Typography>

              <TextField
                fullWidth
                label="E-Mail Id"
                type="email"
                required
                size="small"
                margin="normal"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <TextField
                fullWidth
                label="Password"
                type={hide ? "text" : "password"}
                required
                margin="normal"
                size="small"
                value={verifyPassword}
                onChange={(e) => setVerifyPassword(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setHide(!hide)} edge="end">
                        {hide ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ backgroundColor: "#f04b25", color: "#fff", mt: 2 }}
              >
                Login
              </Button>
            </form>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

